<template>
    <component
        :is="tagName"
        :href="tagName === 'a' ? href : undefined"
        :class="resolvedClass"
        :disabled="isDisabled && tagName === 'button' ? '' : undefined"
        :target="isExternal && tagName === 'a' ? '_blank' : undefined"
        :rel="isExternal && tagName === 'a' ? 'noopener noreferrer' : undefined"
    >
        <DsIcon v-if="iconLeft" :name="iconLeft" class="ds-chip__icon" :width="16" :height="16" :is-in-storybook />
        <span v-else-if="imageLeftUrl" class="ds-chip__icon">
            <img :src="imageLeftUrl" class="ds-chip__image" width="28" height="28" alt="" />
        </span>

        <span class="ds-chip__inner">
            <slot></slot>
        </span>

        <DsIcon v-if="iconRight" :name="iconRight" class="ds-chip__icon" :width="16" :height="16" :is-in-storybook />
        <span v-else-if="imageRightUrl" class="ds-chip__icon">
            <img :src="imageRightUrl" class="ds-chip__image" width="28" height="28" alt="" />
        </span>
    </component>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { SvgIcons } from "../icon/types";
import DsIcon from "../icon/ds-icon.vue";

const props = withDefaults(
    defineProps<{
        /**
         * Set tag
         */
        tag?: "a" | "button" | "span" | "div" | "auto";
        /**
         * Select from types
         * will show different styles
         */
        type?: "assist" | "filter" | "input" | "suggestion";
        /**
         * Set theme
         */
        theme?: "light" | "dark";
        /**
         * Set link
         */
        href?: string;
        /**
         * Set active state
         */
        isActive?: boolean;
        /**
         * Set disabled state
         */
        isDisabled?: boolean;
        /**
         * Set passive state
         */
        isPassive?: boolean;
        /**
         * Set icon left
         */
        iconLeft?: SvgIcons;
        /**
         * Set icon right
         */
        iconRight?: SvgIcons;
        /**
         * Sets url for left img
         */
        imageLeftUrl?: string;
        /**
         * Set url for right img
         */
        imageRightUrl?: string;
        /**
         * Set link as external
         * opens in new window
         */
        isExternal?: boolean;
        /**
         * Set SB icon path
         */
        isInStorybook?: boolean;
    }>(),
    {
        tag: "span",
        type: "assist",
        theme: "light",
        isInStorybook: false,
    }
);

const tagName = computed(() => {
    if (props.tag === "auto") {
        return props.href ? "a" : "button";
    }
    return props.tag;
});

const isDisabled = computed(() => props.isDisabled || props.isPassive);

const resolvedClass = computed(() => [
    `ds-chip`,
    `ds-chip--${props.type}`,
    props.isActive ? "ds-chip--active" : "",
    isDisabled.value ? "ds-chip--disabled" : "",
]);
</script>
